import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import LanguageSelector from './LanguageSelector';
import { Helmet } from 'react-helmet-async';

const RulesPage = () => {
  const { t, language } = useLanguage();

  const handleBackClick = () => {
    window.location.href = '/';
  };

  // Functie om paragrafen met line breaks te formatteren
  const formatContentWithLineBreaks = (content) => {
    // Split de tekst op \n\n en maak een array van paragrafen
    const paragraphs = content.split('\n\n');
    
    // Als er maar één paragraaf is, geef de content direct terug
    if (paragraphs.length === 1) {
      return content;
    }
    
    // Geef een JSX array terug met paragrafen en line breaks
    return paragraphs.map((paragraph, index) => (
      <React.Fragment key={index}>
        {paragraph}
        {index < paragraphs.length - 1 && (
          <>
            <br />
            <br />
          </>
        )}
      </React.Fragment>
    ));
  };

  return (
    <React.Fragment>
      <Helmet>
        <html lang={language} />
        <title>{t('gameRules.title')} | Qwixx Online</title>
        <meta name="description" content={t('gameRules.overview')} />
        <link rel="canonical" href="https://qwixx-online.nl/rules" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={`${t('gameRules.title')} | Qwixx Online`} />
        <meta property="og:description" content={t('gameRules.overview')} />
        <meta property="og:site_name" content="Qwixx Online" />
        <meta property="og:url" content="https://qwixx-online.nl/rules" />
        <meta property="og:image" content="https://qwixx-online.nl/logo192.png" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={`${t('gameRules.title')} | Qwixx Online`} />
        <meta name="twitter:description" content={t('gameRules.overview')} />
        
        {/* Additional SEO tags */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      
      <div className="rules-page">
        <header>
          <div className="back-button-container">
            <button 
              onClick={handleBackClick}
              className="back-button"
              style={{
                background: '#3b82f6',
                color: 'white',
                border: 'none',
                borderRadius: '0.375rem',
                padding: '0.5rem 1rem',
                margin: '1rem',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              ← {t('common.back')}
            </button>
          </div>
          <div className="language-selector-container" style={{ position: 'absolute', top: '1rem', right: '1rem' }}>
            <LanguageSelector />
          </div>
          <h1 style={{ 
            textAlign: 'center', 
            marginBottom: '1.5rem',
            background: 'linear-gradient(to right, #ef4444, #f59e0b, #10b981, #3b82f6)',
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
            color: 'transparent',
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.1)',
            fontSize: '2.5rem',
            fontWeight: '700',
            padding: '0 1rem'
          }}>
            {t('gameRules.title')}
          </h1>
        </header>
        
        <div className="rules-content" style={{
          maxWidth: '800px',
          margin: '0 auto',
          padding: '1rem 2rem',
          backgroundColor: 'white',
          borderRadius: '0.5rem',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        }}>
          <p style={{ fontSize: '1.1rem', marginBottom: '1.5rem' }}>{t('gameRules.overview')}</p>
          
          {/* Dynamically display all game rule sections */}
          {Array.from({ length: 11 }, (_, i) => (
            <div key={i}>
              <h3 style={{ 
                color: '#4b5563', 
                marginTop: '1.5rem',
                marginBottom: '0.5rem',
                fontSize: '1.25rem',
                fontWeight: '600'
              }}>
                {t(`gameRules.sections.${i}.title`)}
              </h3>
              <p style={{ lineHeight: '1.6' }}>
                {formatContentWithLineBreaks(t(`gameRules.sections.${i}.content`))}
              </p>
            </div>
          ))}

          {/* Donation section - Temporarily disabled (no brand license yet) */}
          {/* <div style={{
            marginTop: '2rem',
            textAlign: 'center',
            padding: '1.5rem',
            borderTop: '2px solid #e5e7eb'
          }}>
            <p style={{
              fontSize: '1.1rem',
              fontWeight: '600',
              marginBottom: '1rem',
              color: '#374151'
            }}>
              {t('gameRules.donation')}
            </p>
            <img
              src="/bmc_qr.png"
              alt="Scan QR code to support Qwixx Online with a coffee donation"
              style={{
                maxWidth: '200px',
                height: 'auto',
                margin: '0 auto',
                display: 'block'
              }}
            />
          </div> */}

          <div style={{ marginTop: '2rem', paddingTop: '1rem', borderTop: '1px solid #e5e7eb' }}>
            <h3 style={{ color: '#4b5563', fontSize: '1.1rem', fontWeight: '600' }}>{t('disclaimer.title')}</h3>
            <p style={{ fontSize: '0.9rem', color: '#6b7280', lineHeight: '1.5' }}>{t('disclaimer.content')}</p>
          </div>
        </div>

        <footer style={{ 
          textAlign: 'center', 
          marginTop: '2rem', 
          padding: '1rem',
          color: '#6b7280',
          fontSize: '0.875rem'
        }}>
          © 2025 Qwixx Online
        </footer>
      </div>
    </React.Fragment>
  );
};

export default RulesPage; 